import components from '../../shared/components'
import opacity from '../../shared/opacity'
import shadows from '../../shared/shadows'
import spacing from '../../shared/spacing'
import { fontSizes, fontConfig, fonts } from '../../shared/typography'

import colors from './colors'

export default {
  colors,
  components,
  opacity,
  shadows,
  space: spacing,
  fontSizes,
  fontConfig,
  fonts,
}
